import React, { useCallback, useRef } from 'react';
import { usePdf } from '@mikecousins/react-pdf';

export default function PdfImageConverter({ url, page, onImageReady }) {
  const canvasRef = useRef(null);

  const onPageRenderSuccess = useCallback(() => {
    if (canvasRef.current) {
      onImageReady(canvasRef.current.toDataURL());
    }
  }, [onImageReady]);

  usePdf({
    file: url,
    page,
    canvasRef,
    onPageRenderSuccess,
    scale: 1.5,
  });
  return (
    <div className='relative'>
      <canvas ref={canvasRef} className='absolute invisible' />
    </div>
  );
}
